import React from "react";

const MentorSection = () => {
  return (
    <section className="section" style={{ background: "#050505" }}>
      <div className="container" style={{
        display: "grid",
        gridTemplateColumns: "1fr 1.2fr",
        gap: 60,
        alignItems: "center",
      }}>
        <div style={{
          borderRadius: 24,
          overflow: "hidden",
          border: "1px solid rgba(245,196,0,0.35)",
          background: "#000",
          position: "relative",
          boxShadow: "0 30px 80px -20px rgba(245,196,0,0.25)",
        }}>
          <img
            src={`${process.env.PUBLIC_URL || ""}/assets/bruno-reis.png`}
            alt="Bruno Reis - Fundador da VSA Comunidade"
            style={{ width: "100%", display: "block", borderRadius: 24 }}
          />
        </div>
        <div>
          <div className="eyebrow">CONHEÇA SEU MENTOR</div>
          <h2 className="h-title" style={{ marginTop: 14 }}>
            Bruno <span className="yellow">Reis</span>
          </h2>
          <div style={{ marginTop: 20, color: "rgba(255,255,255,0.8)", fontSize: 16.5, lineHeight: 1.75 }}>
            <p>Fundador da VSA Comunidade e um dos primeiros criadores a construir um ecossistema de vendas com IA realista dentro do TikTok Shop.</p>
            <p style={{ marginTop: 14 }}>Não cheguei aqui por acidente. Cheguei porque enquanto a maioria ainda tentava entender a plataforma, eu já estava testando, errando e ajustando — até encontrar o sistema que funcionava de verdade.</p>
            <p style={{ marginTop: 14 }}>O resultado? <span className="yellow"><strong>Mais de R$2 milhões em GMV gerado. Mais de 2.000 alunos ativos vendendo com o mesmo método.</strong></span> Tudo isso sem investir um centavo em tráfego pago.</p>
            <p style={{ marginTop: 14 }}>Hoje eu não ensino teoria. Eu ensino o que eu mesmo uso todo dia — a estrutura que cria vídeos que vendem, constrói perfis que convertem e escala resultados com ou sem aparecer.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MentorSection;
